


































































































































import {
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import VerificationCode from "@/employee/components/shared/VerificationCode.vue";
import moment from "moment";
import { LoginRouteNames } from "@/shared/loginRoutes";
import {
  FeatureFlags,
  CampaignDecision,
  EbtoResponse
} from "@/shared/types";
import * as routeNames from "@/employee/route-names";
import HsabLoginWrapper from "@/shared/components/ui/HsabLoginWrapper.vue";
import { useEbtoStore } from "@/shared/store/ebto";

const HsabPartnerId = 15;
const VerificationType = {
  Unknown: 0,
  Email: 1,
  SMS: 2,
  Voice: 3
};

@Component({
  components: { VerificationCode, HsabLoginWrapper },
  props: [ "" ]
})

export default class EbtoVerificationCode extends Vue {
  ebtoStore = useEbtoStore();
  isTimerRunning = false;
  isUserLocked = false;
  LoginRouteNames = LoginRouteNames;
  HsabPartnerId = HsabPartnerId;
  timerInSeconds = null;
  verificationCode = "";
  methodSelected = "";
  methodSelectionConfirmed = false;
  EMAIL_ICON = "fa-solid fa-envelope";
  SMS_ICON = "fa-solid fa-sms";
  VOICE_ICON = "fa-solid fa-phone";

  mounted () {
    if (this.ebtoStore.verifiedUser.userLocked) {
      this.displayLockOutTimer(this.ebtoStore.verifiedUser.lockEndTime);
    }
    if (this.ebtoStore.isVerificationLocked) {
      const lockEndTime = moment(new Date()).add(30, "m").toDate();
      this.displayLockOutTimer(lockEndTime);
    }
  }

  @Watch("ebtoStore.isVerificationLocked")
  setLockedVerificationTimer (locked) {
    if (locked) {
      this.resetForm(null);
      const lockEndTime = moment(new Date()).add(30, "m").toDate();
      this.ebtoStore.setLockOnVerifiedUser(lockEndTime as any);
      this.displayLockOutTimer(lockEndTime);
    }
  }

  get isNextButtonDisabled (): boolean {
    return this.isUserLocked;
  }

  displayLockOutTimer (lockEndTime: any): Promise<void> {
    if (this.isTimerRunning) {
      return;
    }
    return new Promise(resolve => {
      const moment1 = moment.utc(lockEndTime);
      const moment2 = moment(new Date());
      const momentDiff = moment1.diff(moment2, "seconds");
      this.timerInSeconds = momentDiff;
      const disableInterval = setInterval(() => {
        if (this.timerInSeconds > 1) {
          this.isUserLocked = true;
          this.timerInSeconds -= 1;
        } else {
          clearInterval(disableInterval);
          this.timerInSeconds = null;
          this.isUserLocked = false;
          this.isTimerRunning = false;
          resolve();
        }
      }, 1000);
    });
  }

  get formattedTimerDisplay (): string {
    if (this.timerInSeconds) {
      const format = (x: number) => x.toString().padStart(2, "0");
      const duration = moment.duration(this.timerInSeconds, "seconds");
      return `${format(duration.hours())}:${format(duration.minutes())}:${format(duration.seconds())}`;
    }
    return "";
  }

  confirmDeliveryMethod () {
    this.methodSelectionConfirmed = true;
    this.onResendVerificationCode();
  }

  onResendVerificationCode (): Promise<void> {
    return new Promise(resolve => {
      if (this.isNextButtonDisabled) {
        return;
      } else {
        const verificationType = this.getSelectedVerificationType;
        this.ebtoStore.resendVerificationCode(verificationType);
      }
      resolve();
    });
  }

  get getSelectedVerificationType (): number {
    switch (this.methodSelected) {
      case "Email":
        return VerificationType.Email;
      case "SMS Text Message":
        return VerificationType.SMS;
      case "Voice Call":
        return VerificationType.Voice;
      default:
        return VerificationType.Unknown;
    }
  }

  onIdentityProofingVerifySubmit () {
    const verificationRequest = {
      verificationCode: this.verificationCode,
      verificationType: this.getSelectedVerificationType
    };
    this.ebtoStore.verifyUser(verificationRequest)
        .then(() => {
          if (!this.ebtoStore.verifiedUser.userId) {
            return;
          }
          if (this.ebtoStore.verifiedUser.decision === CampaignDecision.Stay) {
            this.$router.push({ name: routeNames.EbtoRetained });
            return;
          }
          if (this.ebtoStore.verifiedUser.decision === CampaignDecision.TransferOut) {
            this.$router.push({ name: routeNames.EbtoTransferOutComplete });
            return;
          }
          this.$router.push({ name: routeNames.EbtoGeneralInformation });
        });
  }

  resetForm (e): void {
    this.methodSelected = "";
    this.methodSelectionConfirmed = false;
  }

  maskEmail (email: string): string {
    let maskedEmail = `${email}`;
    const regex = new RegExp("(\\w\\w)(.+?)(@)(\\w)(.+?)(.\\w+$)", "gm");
    const subst = `$1*****$3$4*****$6`;
    maskedEmail = maskedEmail.replace(regex, subst);
    return maskedEmail;
  }

  get hasValidPhoneNumber (): boolean {
    return this.ebtoStore.verifiedUser.phone && this.ebtoStore.verifiedUser.phone !== "" &&
        this.ebtoStore.verifiedUser.phone.length > 9;
  }

  get hasValidEmail (): boolean {
    return this.ebtoStore.verifiedUser.email && this.ebtoStore.verifiedUser.email !== "" &&
        this.ebtoStore.verifiedUser.email.includes("@");
  }
}

